module.exports = {
  CopyMonthSetting: 'CopyMonth设置',
  FinanceSetting: '财务数据设置',
  HrSetting: 'HR数据设置',
  MonthlyDataArchive: '月度数据Archive',
  MonthlyFinance: '每月固定日期(财务)',
  MonthlyHr: '每月固定日期(HR)',
  MonthDataArchive: '月中数据Archive',
  WeeklyDay: '每星期',
  SetJudgmentCriteria: '设置差异判断条件',
  ExportingData: '正在导出数据...',
  ExportActualAmountData: '导出Accpac销账数据',
  ExportInvoiceData: '导出Accpac发票数据',
  ExportBillingData: '导出Accpac海外账单数据',
  SelectDataWithInvoiceNumber: '请选择有发票号的数据。',
  SelectDataWithBillingNumber: '请选择有账单号的数据。'
}
